import { Application } from '../../shared/clients/adventure/bean/application';
// NOTES : essai à généraliser si ok
interface RemoteData {
  loading: boolean;
  error: Error | null;
}

interface ExploreSettings {
  filters: {
    areas: Array<string>
  }
}

export enum ApplicationTypes {
  FullScope = 'FullScope',  // Parcoursup...
  MixScope =  'MixScope',   // CMQ, Oraccle...
  School =    'School'      // Neoma...
}

export interface FeatureSettings {
  expeditions: boolean;
  explore: ExploreSettings;
  authUseSso: boolean;
  dataTab: boolean;
  itinerariesTab: boolean;
  testimonyIntention: boolean;
  testimonyUrl: string;
  companyIntention: boolean;
  jobTeaserPrefix: string;
  diplomaTypes: boolean;
  bridges: boolean;
  applicationType: string;
}

export type FeatureTypes =
  | 'expeditions'
  | 'authUseSso'
  | 'dataTab'
  | 'itinerariesTab'
  | 'testimonyIntention'
  | 'testimonyUrl'
  | 'companyIntention'
  | 'jobTeaserPrefix'
  | 'diplomaTypes'
  | 'bridges';

export interface FeatureSettingsState extends RemoteData, FeatureSettings {}

export interface SettingsState {
  features: FeatureSettingsState;
  // NOTES: ajouter à l'avenir tout ce qui touche aux paramètres de l'application
  //   application: string;
  //   product: string;
}

export const initialSettingsState = {
  features: {
    expeditions: false,
    explore: null,
    authUseSso: false,
    dataTab: false,
    itinerariesTab: false,
    testimonyIntention: false,
    testimonyUrl: null,
    companyIntention: false,
    jobTeaserPrefix: null,
    diplomaTypes: false,
    bridges: false,
    applicationType: null,
    loading: false,
    error: null
  }
};
